import {
  Address,
  BrightyListItem,
  DetailsListItem,
  Grid,
  ListContentIsland,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { useBusinessQuery } from '../../../api/businesses';
import { ApiTokensIsland } from './Token/ApiTokensIsland';
import { WebhooksIsland } from './Webhook/WebhooksIsland';
import { useHasRole } from '../../../api/access';

export function BusinessPage() {
  const { t } = useTranslation();
  const isViewer = useHasRole('VIEWER');
  const isAdmin = useHasRole('ADMIN');
  const businessQuery = useBusinessQuery();

  const business = businessQuery.data?.business;

  return (
    <MainLayout title={t('Your business')} compact>
      <Grid size={12}>
        <ListContentIsland title={t('Business information')}>
          {businessQuery.data?.profile.username ? (
            <DetailsListItem
              label={t('Username')}
              value={`@${businessQuery.data?.profile.username}`}
              loading={businessQuery.isPending}
            />
          ) : null}
          <DetailsListItem
            label={t('Legal name of company')}
            value={businessQuery.data?.business.name}
            loading={businessQuery.isPending}
          />
          <DetailsListItem
            label={t('Founding date')}
            value={business?.incorporationInfo?.incorporationDate}
            loading={businessQuery.isPending}
          />
          <DetailsListItem
            label={t('Legal Type')}
            value={business?.legalType}
            loading={businessQuery.isPending}
          />
          <DetailsListItem
            label={t('Incorporation place')}
            value={
              <Address
                country={business?.incorporationInfo?.incorporationPlace?.country}
                city={business?.incorporationInfo?.incorporationPlace?.city}
              />
            }
            loading={businessQuery.isPending}
          />
          <DetailsListItem
            label={t('Registration number')}
            value={business?.regNumber}
            loading={businessQuery.isPending}
          />
          <DetailsListItem
            label={t('Legal address')}
            value={
              <Address
                country={business?.address?.country}
                zipCode={business?.address?.zipCode}
                region={business?.address?.region}
                city={business?.address?.city}
                streetLine1={business?.address?.streetLine1}
                streetLine2={business?.address?.streetLine2}
              />
            }
            loading={businessQuery.isPending}
          />
          <DetailsListItem
            label={t('Operational address')}
            value={
              <Address
                country={business?.operationalAddress?.country}
                zipCode={business?.operationalAddress?.zipCode}
                region={business?.operationalAddress?.region}
                city={business?.operationalAddress?.city}
                streetLine1={business?.operationalAddress?.streetLine1}
                streetLine2={business?.operationalAddress?.streetLine2}
              />
            }
            loading={businessQuery.isPending}
          />
        </ListContentIsland>
      </Grid>
      {isAdmin && __API_DOCS_URL__ ? (
        <>
          <Grid size={12}>
            <ApiTokensIsland />
          </Grid>
          <Grid size={12}>
            <WebhooksIsland />
          </Grid>
        </>
      ) : null}
      <Grid size={12}>
        <ListContentIsland>
          {__ABOUT_URL__ ? (
            <BrightyListItem<'a'> title={t('About')} href={__ABOUT_URL__} target="_blank" />
          ) : null}
          {__HELP_URL__ ? (
            <BrightyListItem<'a'> title={t('Help')} href={__HELP_URL__} target="_blank" />
          ) : null}
          {isViewer ? (
            <BrightyListItem<'a'> title={t('Pricing')} href="/account/business/pricing" />
          ) : null}
        </ListContentIsland>
      </Grid>
    </MainLayout>
  );
}
